import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="header">
      <div className="logo">
        <img src="/duck_icon.ico" alt="Logo" className="logo-icon" />
        DiverDuck e.V.
      </div>

      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>
          Startseite
        </Link>
        <div className="dropdown">
          <Link
            className="has-submenu"
            to="/training"
            onClick={() => setMenuOpen(false)}
          >
            Training
          </Link>
          <div className="dropdown-content">
            <a href="/training#team" onClick={() => setMenuOpen(false)}>
              Trainerteam
            </a>
            <a href="/training#konzept" onClick={() => setMenuOpen(false)}>
              Trainingskonzept
            </a>
            <a href="/training#zeiten" onClick={() => setMenuOpen(false)}>
              Trainingszeiten
            </a>
            <a
              href="/training#schnuppertraining"
              onClick={() => setMenuOpen(false)}
            >
              Schnuppertraining
            </a>
          </div>
        </div>
        <div className="dropdown">
          <Link
            className="has-submenu"
            to="/tauchen"
            onClick={() => setMenuOpen(false)}
          >
            Tauchen
          </Link>
          <div className="dropdown-content">
            <a href="/tauchen#intro" onClick={() => setMenuOpen(false)}>
              Einsteiger
            </a>
            <a href="/tauchen#ausbildung" onClick={() => setMenuOpen(false)}>
              Tauchausbildung
            </a>
            <a href="/tauchen#ausflug" onClick={() => setMenuOpen(false)}>
              Vereinsausflug
            </a>
            <a
              href="/tauchen#schnuppertauchen"
              onClick={() => setMenuOpen(false)}
            >
              Schnuppertauchen
            </a>
          </div>
        </div>
        <Link to="/mitgliedschaft" onClick={() => setMenuOpen(false)}>
          Mitgliedschaft
        </Link>
        <Link to="/verein" onClick={() => setMenuOpen(false)}>
          Verein
        </Link>
        <Link to="/kontakt" onClick={() => setMenuOpen(false)}>
          Kontakt
        </Link>
      </nav>

      <button className="menu-toggle" onClick={toggleMenu}>
        ☰
      </button>
    </header>
  );
}
